import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';

interface IMeasurementsProperties {
    name: string;
    value: string;
}

interface IMeasurements {
    id: string;
    carCapturedTimestamp: string;
    properties: IMeasurementsProperties[];
}

export interface IMeasurementsResponse {
    data?: IMeasurements[];
}

/** /measurements docs: https://cardata.apps.emea.vwapps.io/documentation#tag/Measurements/operation/getMeasurements */

export class VcfMeasurementsClient {
    private readonly headers: HeadersInit = {
        'User-Id': '__userId__',
        'Content-Type': 'application/json;version=1',
    };

    private readonly resourceHostId: string;

    constructor(
        private readonly authService: IAuthServiceV2,
        private readonly stage: string,
        private readonly gdcType: string,
    ) {
        this.resourceHostId = `myvw-vcf-${this.stage}`;
    }

    public async getMeasurementsStatus(vin: string, id: string = 'range'): Promise<IMeasurementsResponse> {
        const url = `vehicles/${vin}/measurements?gdc=${this.gdcType}&id=${id}`;
        const response = await this.authService.get(this.resourceHostId, url, this.headers);

        if (!response.ok) {
            throw new Error(`Request to /measurements failed with status code ${response.status}`);
        }

        return await response.json();
    }
}
